const SuccessStoryElementTagModel = {
  position: 1,
  name: {
    pl: '',
    en: '',
  },
};

export default SuccessStoryElementTagModel;
